// extracted by mini-css-extract-plugin
export default {"text":"Rules_text__Qnh0Q","list":"Rules_list__K1teb","subtitle":"Rules_subtitle__6n51I","title":"Rules_title__236yY","header":"Rules_header__Mvpi+","content":"Rules_content__wY7R1"};